import {classes} from './grid-layout.st.css';

/**
 * @deprecated use `gridLayoutStretchAllChildren`
 */
export function gridLayoutWithStretchedContent () {
    return classes.gridLayoutWithStretchedContent;
}

export function gridLayoutStretchAllChildren () {
    return classes.gridLayoutStretchAllChildren;
}

export function gridLayoutCenterAllChildren () {
    return classes.gridLayoutCenterAllChildren;
}

export function gridLayoutWithEvenColumns (columnsCount: 2 | 3) {
    switch (columnsCount) {
        case 2: return classes.gridLayoutWithEvenColumns2;
        case 3: return classes.gridLayoutWithEvenColumns3;
    }
}

export function gridLayoutSpanAllColumns () {
    return classes.gridLayoutSpanAllColumns;
}

export function gridLayoutColumn () {
    return classes.gridLayoutColumn;
}

export function gridLayoutEvenlyDistributedRow () {
    return classes.gridLayoutEvenlyDistributedRow;
}

export function gridAlignSelf (alignment: 'center' | 'start' | 'end') {
    switch (alignment) {
        case 'center': return classes.gridAlignSelfCenter;
        case 'start': return classes.gridAlignSelfStart;
        case 'end': return classes.gridAlignSelfEnd;
    }
}